import { render } from "./AddClientAffecterPage.vue?vue&type=template&id=589a6a5b&ts=true"
import script from "./AddClientAffecterPage.vue?vue&type=script&lang=ts"
export * from "./AddClientAffecterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__